const configMember = {
    member: {
        listLayout: 'MemberListDefaultLayout',
        filterLayout: 'MemberFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getMember',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            obt:'created_at',
            obs:'desc'
        },
    },
    create: {
        writeLayouts: ['MemberWriteCreateLayout'],
        getFunc: '',
        writeFunc: 'createMember',
        directUrl: '/member',
        writeApiParamSet: {
          mb_no: '',
        },
        writeSuccessType: 1,
        parsingData: {
            id: 'mb_id',
            idCheckDuplicate: '',
            password: 'mb_password',
            passwordConfirm: 'mb_password_confirmation',
            nick: 'mb_nick',
            nickCheckDuplicate: '',
        },
    },
    detail: {
        writeLayouts: ['MemberWriteDefaultLayout'],
        getFunc: 'getMemberDetail',
        detailApiParamsSet: {
        },
        writeFunc: 'updateMember',
        writeApiParamSet: {
            mb_no: '',
        },
        validateCheck: [
            'password',
            'passwordConfirm',
            'phone',
        ],
        essentialValidateCheck: [
            'nick',
        ],
        parsingData: {
            password: 'new_password',
            passwordConfirm: 'new_password_confirmation',
            nick: 'mb_nick',
            phone: 'mb_hp',
            // status: 'mb_premium',
            sns_1: 'mb_sns_1',
            sns_2: 'mb_sns_2',
            sns_3: 'mb_sns_3',
            introduce: 'mb_introduce',
        },
        fileInfo:[
            // {   fileName :'thumbnail', fileType :'profileThumb',},
            {   fileName :'profile', fileType :'profile',},
            {   fileName :'background', fileType :'profileBack',},
        ],
        directUrl: '',
        directType: '',
        keyName: 'no',
        writeKeyName: 'mb_no',
        writeSuccessType: 1,
        writeFailTypes: {
            // '-223': '중복된 이메일입니다.',
            // '-222': '중복된 닉네임입니다.',
        },
    },
    update: {
        writeLayouts: ['MemberWriteUpdateLayout'],
        getFunc: 'getUpdateMember',
        detailApiParamsSet: {
        },
        getDetailParamsKey: 'no',
        writeFunc: 'updateMember',
        writeApiParamSet: {},
        directUrl: '',
        directType: '',
        fileType: 'profile',
        keyName: 'mb_no',
        writeSuccessType: 1,
        writeFailTypes: {
            // '-223': '중복된 이메일입니다.',
            // '-222': '중복된 닉네임입니다.',
        },
    },
    curator: {
        listLayout: 'MemberListCuratorLayout',
        filterLayout: 'MemberFilterCuratorLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getCurator',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    curatorDetail: {
        detailLayout: 'MemberDetailCuratorLayout',
    },
    curatorUpdate: {
        writeLayouts: ['MemberWriteCuratorLayout'],
        getFunc: 'getCurator',
        detailApiParamsSet: {
            ip: 1,
        },
        getDetailParamsKey: 'no',
        writeFunc: 'updateCurator',
        writeApiParamSet: {},
        directUrl: '',
        directType: '',
        fileType: 'profile',
        keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {
            // '-223': '중복된 이메일입니다.',
            // '-222': '중복된 닉네임입니다.',
        },
    },
    quit: {
        listLayout: 'MemberListQuitLayout',
        filterLayout: 'MemberFilterQuitLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getQuitMember',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    portfolioEdit: {
        writeLayouts: ['MemberWritePortfolioLayout'],
        getFunc: 'getMemberDetail',
        detailApiParamsSet: {
        },
        writeFunc: 'updateMember',
        writeApiParamSet: {

        },
        parsingData: {
            portfolio: 'mb_portfolio'
        },
        fileInfo: [],
        directUrl: '',
        keyName: 'no',
        writeKeyName: 'mb_no',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
    setNick: {
        writeLayouts: [],
        getFunc: 'getMemberDetail',
        detailApiParamsSet: {
        },
        writeFunc: 'updateMember',
        writeApiParamSet: {
            mb_no: '',
        },
        validateCheck: [],
        essentialValidateCheck: [],
        parsingData: {},
        fileInfo:[],
        directUrl: '',
        directType: '',
        keyName: 'no',
        writeKeyName: 'mb_no',
        writeSuccessType: 1,
        writeFailTypes: {
            // '-223': '중복된 이메일입니다.',
            // '-222': '중복된 닉네임입니다.',
        },
    },
    itemAuto:{
        listLayout: 'MemberListItemAutoLayout',
        filterLayout: 'MemberFilterItemAutoLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getMember',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            obt:'created_at',
            obs:'desc',
            use:1,
        },
    },
}
import util from "@/mixins/util";

export default {
    methods: {
        returnMemberConfig(type) {
            return configMember[type];
        },

    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        na: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        gid: {
            type: 'terms',
            classname: 'filterCuratorType',
            option:{
                1: [1, 7, 8],
              }
        },
        pr: {
            type: 'terms',
            classname: 'filterMemberType',
        },
        use: {
            type: 'match',
            classname: 'filterUse',
        },
        join: {
            type: 'between',
            classname: 'filterJoinDate',
            option: {
                start: 'joinst',
                end: 'joined'
            }
        },
        out: {
            type: 'between',
            classname: 'filterOutDate',
            option:{
                start: 'outst',
                end: 'outed'
            }
        },
		re: {
			type: 'query',
			classname: 'searchInput',
		},
    }
}
